import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/administrative-unit";

export const pagingAdministrativeUnit = searchAdministrativeUnit => axios.post(API_PATH + "/search-by-dto", searchAdministrativeUnit);

export const saveAdministrativeUnit = administrativeUnit => axios.post(API_PATH + "/save-or-update", administrativeUnit);

export const getAdministrativeUnitById = administrativeUnitId => axios.get(API_PATH + "/" + administrativeUnitId);

export const deleteAdministrativeUnit = administrativeUnitId => axios.delete(API_PATH + "/" + administrativeUnitId)

export const getAllAdministrativeUnitByLevel = level => axios.get(API_PATH + "/get-all-by-level/" + level);

export const getAllAdministrativeByParentId = parentId => axios.get(API_PATH + "/get-all-child-by-parent-id/" + parentId);

export const getRootAdministrativeUnit = parentId => axios.get(API_PATH + "/get-all-child-by-parent-id/" + parentId);
export const getAllAdministrativeWithHotKey = () => axios.get(API_PATH + "/get-all-administrative-hot-key");

export const generateHotKeyByLevel = level => axios.post(API_PATH + "/generate-hot-key-by-level", level)